import moment from 'moment';

const QUARTER_MAP = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]];

/**
  默认选中时间规则（前端）：
  1、当前时间在可选范围时间内时：
  当前时间往后推3个刻度（选中4个刻度），如果可以成功推3个刻度，那么选中这4个刻度；(例如：当前是2023Q1,可选时间2022Q4-2023Q4，默认选中2023Q1-2023Q4)
  如果不能成功推3个刻度（例如当前时间往后不可选，或者只能选不足3个刻度），此时从最后一个可选时间刻度往前推3个刻度，如果可以成功推3个刻度，那么选中这4个刻度；(例如：当前是2023Q1,可选时间2022Q4-2023Q3，默认选中2022Q4-2023Q3)
  如果最后一个可选时间刻度往前推不了3个刻度，那么选择起始可选时间到结束可选时间；(例如：当前是2023Q1,可选时间2022Q4-2023Q2，默认选中2023Q4-2023Q2)
  2、当前时间在可选时间范围之后（不在可选范围）：
  首先从最后一个可选时间刻度开始，往前推3个刻度，如果可以成功推3个刻度，那么选中这4个刻度；(例如：当前是2023Q1,可选时间2022Q1-2022Q4，默认选中2022Q1-2022Q4)
  如果不能成功推3个刻度，那么选择起始可选时间到结束可选时间；(例如：当前是2023Q1,可选时间2022Q3-2022Q4，默认选中2022Q3-2022Q4)
  3、当前时间在可选时间范围之前（不在可选范围）：
  首先从起始可选时间刻度，往后推3个刻度，如果可以成功推3个刻度，那么选中这4个刻度；(例如：当前是2023Q1,可选时间2023Q4-2024Q4，默认选中2023Q4-2024Q3)
  如果不能成功推3个刻度，那么选择起始可选时间到结束可选时间；(例如：当前是2023Q1,可选时间2023Q4-2024Q1，默认选中2023Q4-2024Q1)

  手动选中时间填补数据规则（后端）：
  当用户选中的时间跨度不足4个刻度时，从用户选中的起始时间刻度开始，往后推3个刻度（补齐至4个刻度的数据），此时补齐的也是真实数据，前端用户选中的时间范围跨度不变。
  (例如：用户选择时间2022Q4-2023Q1，此时筛选器展示选中2022Q4-2023Q1，展示的数据为2022Q4-2023Q3，其中2023Q2-2023Q3是后端补充的数据)
  注：以上规则适用与Calendar页面月/季度/年粒度日期筛选器。
 */
const getDefaultSelectDate = (
  startRange: string,
  endRange: string,
  rangeFormat: string,
  type: 'month' | 'quarter' | 'year',
) => {
  const currentV = moment().startOf(type).valueOf();
  const allowMinV = moment(startRange, rangeFormat).valueOf();
  const allowMaxV = moment(endRange, rangeFormat).valueOf();
  let defaultStartV = 0, defaultEndV = 0;
  // 当前时间大于可选最大时间
  if (currentV > allowMaxV) {
    defaultEndV = allowMaxV;
    const tempStartV = moment(allowMaxV).subtract(3, type).valueOf();
    defaultStartV = tempStartV < allowMinV ? allowMinV : tempStartV;
  // 当前时间小于可选最小时间
  } else if (currentV < allowMinV) {
    defaultStartV = allowMinV;
    const tempEndV = moment(allowMinV).add(3, type).valueOf();
    defaultEndV = tempEndV > allowMaxV ? allowMaxV : tempEndV;
  // 当前时间在可选范围内
  } else {
    const tempEndV = moment(currentV).add(3, type).valueOf();
    if (tempEndV > allowMaxV) {
      const tempStartV = moment(allowMaxV).subtract(3, type).valueOf();
      defaultStartV = tempStartV < allowMinV ? allowMinV : tempStartV;
      defaultEndV = allowMaxV;
    } else {
      defaultStartV = currentV;
      defaultEndV = tempEndV;
    }
  }

  return {
    defaultStartV,
    defaultEndV,
  };
}

const getQuarter = (month: string) => {
  if (!month) return '';
  for (let i = 0; i < QUARTER_MAP.length; i ++) {
    const t = QUARTER_MAP[i];
    if (t?.includes(Number(month))) {
      return String(i + 1);
    }
  }
}

export {
  getDefaultSelectDate,
  getQuarter,
}
